export const transformOrderKeys = orders =>
  orders.map(order => {
    const {
      id,
      date,
      time_bucket: timeBucket,
      anytime_today: anytimeToday,
      address,
      home_address: homeAddress,
      car_registration: carRegistration,
      car_model: carModel,
      car_color: carColor,
      postcode,
      image,
      price,
      status
    } = order || {}

    return {
      id,
      date,
      timeBucket,
      anytimeToday,
      address,
      homeAddress,
      carRegistration,
      carModel,
      carColor,
      postcode,
      image,
      price,
      status
    }
  })
